export enum Emotion {
  NORMAL = "Normal",
  HAPPY = "Happy",
  PAIN = "Pain",
  ANGRY = "Angry",
  WORRIED = "Worried",
  SAD = "Sad",
  CRYING = "Crying",
  SHOUTING = "Shouting",
  TEARY_EYED = "Teary-Eyed",
  DETERMINED = "Determined",
  JOYOUS = "Joyous",
  INSPIRED = "Inspired",
  SURPRISED = "Surprised",
  DIZZY = "Dizzy",
  SPECIAL0 = "Special0",
  SPECIAL1 = "Special1",
  SIGH = "Sigh",
  STUNNED = "Stunned",
  SPECIAL2 = "Special2",
  SPECIAL3 = "Special3"
}
